import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useDialog } from '@cnx-saas/common-fe';
import { useSnackbar } from '@cnx-saas/snackbar';
import { useDeleteInvitationMutation } from '../../../api/tenant/mutations';

export function useDeleteInviteDialog(refetch: () => void) {
  const { t } = useTranslation();

  const { openDialog, closeDialog } = useDialog();
  const { addAlert } = useSnackbar();

  const [deleteInvite] = useDeleteInvitationMutation();

  function openDeleteInviteDialog(userId: string) {
    const id = 'revoke-invitation-dialog';
    openDialog({
      id,
      title: t('userManagement.revoke-dialog.title', {
        defaultValue:
          'Are you sure you want to revoke the selected invitation?',
      }),
      content: (
        <Stack width={1} flexDirection="row" justifyContent="end" gap={1}>
          <Button
            variant="outlined"
            color="neutral"
            onClick={() => closeDialog(id)}
          >
            {t('userManagement.revoke-dialog.cancel-button.label', {
              defaultValue: 'Cancel',
            })}
          </Button>
          <Button
            color="error"
            onClick={async () => {
              closeDialog(id);
              try {
                const { data } = await deleteInvite({
                  variables: {
                    details: {
                      userId,
                    },
                  },
                });
                refetch();

                if (data?.sendInvitation.message !== 'ok') {
                  addAlert({
                    type: 'error',
                    children:
                      data?.sendInvitation.message ??
                      t(
                        'userManagement.revoke-dialog.invitation-deleted-alert.error-title',
                        { defaultValue: 'An error occured' },
                      ),
                  });
                } else {
                  addAlert({
                    type: 'success',
                    children: t('userManagement.form.invite.revokeSuccess', {
                      defaultValue: 'Invitation revoked',
                    }),
                  });
                }
              } catch (e) {
                addAlert({
                  type: 'error',
                  children: t(
                    'userManagement.revoke-dialog.invitation-revoke-alert.error-title',
                    { defaultValue: 'An error occured' },
                  ),
                });
              }
            }}
          >
            {t('userManagement.actionlabel.revoke', { defaultValue: 'Revoke' })}
          </Button>
        </Stack>
      ),
    });
  }

  return { openDeleteInviteDialog };
}
